import React from 'react';


const HomePage = () => {
  return (
    <div>
      <h1>Welcome to Travel Website</h1>
    </div>
  );
};

export default HomePage;
